export default {
      id: "ic-plan-intercommunalites-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-intercommunalites-usage",
      toString: function () {
        return this.url;
      }
    }